import { emptyCharacter } from '../components/EmptyChar'
import { config } from '../config'
import { isNumber } from './is-number'

const defaultMinimumPrecision = 2
const defaultMaximumPrecision = 2

interface FormatCurrency {
  value: number | string
  style?: 'currency'
  locale?: string
  currency?: string
  currencyDisplay?: 'symbol' | 'code'
  notation?: 'standard' | 'compact'
  minimumPrecision?: number
  maximumPrecision?: number
}

export const formatCurrency = ({
  value,
  style,
  locale = config.defaultLocale,
  currency = config.defaultCurrency,
  currencyDisplay = 'symbol',
  notation = 'standard',
  minimumPrecision = defaultMinimumPrecision,
  maximumPrecision = defaultMaximumPrecision,
}: FormatCurrency): string => {
  if (!isNumber(value)) {
    return emptyCharacter
  }

  return new Intl.NumberFormat(locale, {
    style,
    currency,
    currencyDisplay,
    notation,
    minimumFractionDigits: minimumPrecision,
    maximumFractionDigits: maximumPrecision,
  }).format(+value)
}
